function toDate(value: Date | string | undefined): Date | null {
  if (!value) return null

  const date = value instanceof Date ? value : new Date(value)

  return Number.isNaN(date.getTime()) ? null : date
}

export function getExclusiveDateRangeBounds(
  dateRange?: (Date | string | undefined)[]
) {
  if (!dateRange || dateRange.length === 0) {
    return { startDate: null, endDateExclusive: null }
  }

  const [start, end] = dateRange
  const startDate = toDate(start)
  const endDateExclusive = toDate(end)

  if (endDateExclusive) {
    endDateExclusive.setUTCDate(endDateExclusive.getUTCDate() + 1)
  }

  return { startDate, endDateExclusive }
}

export function isDateWithinExclusiveDateRange(
  value: Date | string | undefined,
  dateRange?: (Date | string | undefined)[]
) {
  const date = toDate(value)
  if (!date) return false

  const { startDate, endDateExclusive } = getExclusiveDateRangeBounds(dateRange)

  if (startDate && date < startDate) {
    return false
  }

  if (endDateExclusive && date >= endDateExclusive) {
    return false
  }

  return true
}
